import React, { useContext } from 'react';
import EditorContext from '../Pages/Editor/Context';
import { List } from 'immutable';

import styled from '@emotion/styled';
import { EmbedService } from '../Types';

const Title = styled.strong`
  display: block;
  margin-bottom: 12px;
  text-align: center;
`;

export const UnorderedList = styled.ul`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  list-style-type: none;
  margin-bottom: 0;
  overflow: hidden;
`;

const ListItem = styled.li`
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  text-align: center;
`;

const ServiceImage = styled.img`
  max-width: 90%;
  max-height: 90%;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d8d8d8;
  border-radius: 5px;
  margin: 0 auto 10px;
`;

export const ServiceTitle = styled.span`
  color: #a6a6a6;
  font-size: 12px;
  font-weight: normal;
`;

const Info = styled.p`
  text-align: center;
`;

const InfoLink = styled.a`
  font-weight: normal;
`;

const StyledWrapper = styled.div``;

interface EmbedServicesListProps {
  className?: string;
}

const EmbedServicesList = ({ className }: EmbedServicesListProps) => {
  const context = useContext(EditorContext);
  const services = context.embedServices as List<EmbedService>;

  return (
    <StyledWrapper className={className}>
      <Title>See how to embed</Title>
      <UnorderedList>
        {services
          .map((item) => (
            <ListItem key={item?.id} className={item?.id}>
              <a
                href={item?.helpUrl}
                title={item?.title}
                target='_blank'
                rel='noreferrer'
              >
                <IconWrapper>
                  <ServiceImage src={item?.icon} />
                </IconWrapper>
                <ServiceTitle>{item?.title}</ServiceTitle>
              </a>
            </ListItem>
          ))
          .toArray()}
      </UnorderedList>
      <Info>
        for ideas and how to do embeds read{' '}
        <InfoLink
          target='_blank'
          href='https://help.bonjoro.com/en/articles/5404409-next-gen-message-templates'
        >
          here
        </InfoLink>
      </Info>
    </StyledWrapper>
  );
};

export default EmbedServicesList;
